import * as Sentry from '@sentry/browser'
import lodash from 'lodash'
import sleep from 'sleep-promise'

let sentryUserObject = {}

const initSentry = (props) => {
  const {
    dsn,
    user,
    blockBreadcrumbs,
    blockExceptions,
    userSettings,
    force,
    sendTestError,
  } = {
    ...{
      user:
        lodash.get(global, 'currentUser.user') ||
        lodash.get(global, 'currentUser'),
      blockBreadcrumbs: [],
      blockExceptions: [
        'TypeError: Failed to fetch',
        'Uncaught (in promise) TypeError: Failed to fetch',
        'ResizeObserver loop completed with undelivered notifications.',
        'gCrWeb',
        ...(Array.isArray(props?.blockExceptions) ? props.blockExceptions : []),
      ],
      userSettings: lodash.get(global, 'settings'),
      force: /forceSentry/.test(window.location),
      sendTestError: /testSentry/.test(window.location),
    },
    ...props,
  }

  const isDev =
    (/localhost/.test(window.location) || global.BUILD_COMMIT === 'master') &&
    !force

  if (isDev) {
    return
  }

  if (!dsn || dsn === '') {
    console.error('No sentry dsn provided.')
    return
  }

  let release = global.RELEASE_VERSION
  // console.log(release)
  Sentry.init({
    dsn,
    release: release
      ? release
      : global.BUILD_COMMIT && global.BUILD_COMMIT !== 'master'
      ? global.BUILD_COMMIT
      : undefined,
    maxBreadcrumbs: 500,
    beforeSend: (event) => {
      lodash.set(event, 'user.settings', userSettings)
      const exceptionValue = lodash.get(event, [
        'exception',
        'values',
        0,
        'value',
      ])
      if (blockExceptions.includes(exceptionValue)) {
        global &&
          global.log &&
          global.log('INFO: exception excluded from sentry', exceptionValue)
        return event
      }

      if (event.exception) {
        console.log('Sentry show dialog', { event, blockExceptions })
        Sentry.showReportDialog({
          email: user ? lodash.get(user, 'email') : '',
          name:
            user && user.name
              ? user.name
              : user
              ? `${lodash.get(user, 'prename')} ${lodash.get(user, 'lastname')}`
              : '',
        })
        updateDialogs()
      }
      return event
    },
    beforeBreadcrumb: (breadcrumb, hint) => {
      if (blockBreadcrumbs.includes(breadcrumb.category)) {
        return null
      }
      return breadcrumb
    },
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'TypeError: Failed to fetch',
      'Uncaught (in promise) TypeError: Failed to fetch',
      'ResizeObserver loop completed with undelivered notifications.',
      "undefined is not an object (evaluating '__gCrWeb.instantSearch.clearHighlight')",
    ],
  })

  sentryUserObject = {
    email: lodash.get(user, 'email'),
    name: user?.name
      ? user.name
      : `${lodash.get(user, 'prename')} ${lodash.get(user, 'lastname')}`,
    id: lodash.get(user, 'id'),
  }

  updateSentryUser()

  if (sendTestError) {
    Sentry.captureException(new Error('Test error'))
  }
}

export default initSentry

async function updateDialogs() {
  for (let l = 0; l < 10; l++) {
    const dialogs = document.getElementsByClassName(
      'sentry-error-embed-wrapper',
    )
    // console.log("trying to fix all dialogs")
    if (lodash.isArray(dialogs)) {
      for (let i = 0; i < lodash.size(dialogs); i++) {
        dialogs[i].style.zIndex = 9999
        return
      }
      await sleep(1000)
    }
  }
  console.error('Failed to update sentry dialog z-index')
}

export function updateSentryUser(newValues = {}) {
  sentryUserObject = {
    ...sentryUserObject,
    ...newValues,
  }
  Sentry.setUser(sentryUserObject)
}
